import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lost from "./pages/lost";
import Home from "./pages/index";
import Lookup from "./pages/lookup";
import Photo from "./pages/photo";
import UUID from "./pages/uuid";
import Resume from "./pages/resume";
import Portfolio from "./pages/portfolio";
import Art from "./pages/art";
import Contact from "./pages/contact";
import Servers from "./pages/servers";
import Minecraft from "./pages/minecraft";
import Plex1 from "./pages/PlexOnboard/1verify";
import ReactGA from "react-ga4";
import Art812 from "./pages/art812";
import Privacy from "./pages/privacy";
import JustVin from "./pages/justvin";

ReactGA.initialize("G-RXE1N1HFKS");

const App = () => {
  if (
    !["www", "csfrederick", "192"].includes(
      window.location.host.split(".")[0]
    )
  ) {
    if (window.location.host.split(".")[1] === "116:3000") {
      window.location.href = "http://192.168.1.116:3000/server";
    } else {
      window.location.href = "https://csfrederick.com/server";
    }
  }
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lookup" element={<Lookup />} />
        <Route path="/photo" element={<Photo />} />
        <Route path="/uuid" element={<UUID />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/art" element={<Art />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/foredark_games" element={<Servers />} />
        <Route path="/minecraft" element={<Minecraft />} />
        <Route path="/plexonboard" element={<Plex1 />} />
        <Route path="/art812" element={<Art812 />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/justvin" element={<JustVin />} />
        <Route path="/justvin/privacy" element={<JustVin />} />
        <Route path="/justvin/terms" element={<JustVin />} />
        <Route path="*" element={<Lost />} />
      </Routes>
    </Router>
  );
};

export default App;
